import Phaser from 'phaser'

class Particle extends Phaser.GameObjects.Image {
    constructor(scene, x, y, scale) {
        super(scene, x, y, 'particleWhite')

        this.scaleX = scale || 0.15
        this.scaleY = scale || 0.15
    }
}

export default Particle
